// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import loading from '../../../share/components/vue/ProcessingIcon';
import config from '../../../share/config';
import util from '../../../share/util/utils';

export default {
  name: "multipleSelect",
  data() {
    return {
      processing: false,
      multipleListItems: [],
    };
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        this.updateMultipleTable();
        val; // To avoid warning
      }
    },
  },

  components: {
    'processing-view': loading,
  },

  methods: {
    ...mapActions('auth', ['logout']),

    /**
     * アイコンのクリック処理
     */
    clickItem(item) {
      const routerData = {
        name: item.route_name,
        params: {
          functionName: item.func_name,
        }
      };
      this.$router.push(routerData);
    },

    /**
     * 診断機能一覧のリストを更新する
     */
    updateMultipleTable: function () {
      const menuList = this.multipleMenus ? this.multipleMenus.menu_list : [];
      // メニューサポートからシステムリストを取得
      const ecuArray = this.multipleMenus.menu_list.map((item) => item.system_name);
      const multipleList = [];
      // マルチデータモニタ 診断機能一覧設定確認用
      let isDataMonitorAdd = false;
      // 全カスタマイズ 診断機能一覧設定確認用
      let isCustomizeAdd = false;

      // 各システムの診断機能をチェック
      ecuArray.forEach(ecu => {
        const targetMenu = menuList.find(menu => menu.system_name === ecu);

        if (targetMenu) {
          if (targetMenu.menu_display_config['data_monitor'] && !isDataMonitorAdd) {
            // データモニタの対象で、診断機能一覧にデータモニタが未設定の場合追加
            multipleList.push({
              name: this.$t(`message.label_menu_multi_data_monitor`),
              route_name: 'multipleEcuTable',
              func_name: 'data_monitor',
            });
            isDataMonitorAdd = true;
          }

          if (targetMenu.menu_display_config['customize'] && !isCustomizeAdd) {
            // カスタマイズの対象で、診断機能一覧にカスタマイズが未設定の場合追加
            multipleList.push({
              name: this.$t(`message.label_menu_all_customize`),
              route_name: 'allCustomize',
            });
            isCustomizeAdd = true;
          }
        }
      });

      this.multipleListItems = util.sortItems(multipleList, 'name', config.ASC);
    },

  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      multipleMenus: state => state.vehicle.multipleMenus,
    }),
  },

  created() {
  },

  mounted() {
    // ツリーから診断機能ノードが選択されて遷移してきた時
    if (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'functionId')) {
      switch (this.$route.query.functionId) {
        case 'data_monitor':
          this.$router.push({
            name: config.MULTIPLE_FUNCTION_ECU_TABLE,
            params: {
              functionName: this.$route.query.functionId,
            }
          });
          break;
        case 'customize':
          this.$router.push({
            name: config.MULTIPLE_FUNCTION_ALL_CUSTOMIZE
          });
          break;
        default:
          // noop
      }
      return;
    }
    // タブ制御
    this.$emit("setVehicleTabsAvailable", true);
    this.updateMultipleTable();
  },
};
